import { Controller } from "@hotwired/stimulus"

// One grant row in the Location access editor.
//
// It only toggles VISIBILITY and the disabled flag; the server renders every
// control. With JS off, the country select is the visible one and the form
// still submits a valid grant, so the editor degrades rather than breaking.
//
// Both value controls share the name `[value]`, so exactly one must be enabled
// at a time or the browser sends the wrong one. That is what `disabled` is
// doing here: a disabled control is not submitted.
export default class extends Controller {
  static targets = ["type", "countryWrap", "countryValue", "continentWrap",
                    "continentValue", "worldwideNote", "destroy"]

  connect() {
    this.typeChanged()
  }

  typeChanged() {
    const type = this.typeTarget.value

    this.#show(this.countryWrapTarget, type === "country")
    this.#show(this.continentWrapTarget, type === "continent")
    this.#show(this.worldwideNoteTarget, type === "worldwide")

    this.countryValueTarget.disabled = type !== "country"
    this.continentValueTarget.disabled = type !== "continent"
  }

  // Marks the row for destruction rather than ripping it out of the DOM: a
  // persisted grant needs its _destroy flag to reach the server, and yanking
  // the node would silently leave the record in place.
  async remove() {
    // Adding worldwide is visible and trivially reversible. REMOVING it is
    // silent and lands weeks later, and with the session-sticky bit gone it
    // takes effect on the target's very next request. The owner's own
    // exemption is a row exactly like any other.
    if (this.typeTarget.value === "worldwide") {
      const ok = await window.appConfirm(
        "Remove worldwide access? They will drop to their baseline countries the " +
        "next time they load a page, even if they are travelling right now.",
        { confirmLabel: "Remove it", cancelLabel: "Keep it" }
      )
      if (!ok) return
    }

    if (this.hasDestroyTarget && this.element.querySelector("input[name*='[id]']")?.value) {
      this.destroyTarget.value = "1"
      this.element.classList.add("hidden")
    } else {
      this.element.remove()
    }
  }

  #show(el, visible) {
    el.classList.toggle("hidden", !visible)
  }
}
